<template>
  <div style="padding:20px;">
    <div class="closeCurrntPage" @click="closeCurrntPage">X关闭当前页</div>
    <div flex="main:justify cross:center" class="gap-bottom">
      <div>
        <!-- <el-select v-model="ts" clearable size="mini">
          <el-option v-for="item in tsList" :label="item.provider_name" :value="item.provider_code + ''" :key="item.provider_code"></el-option>
        </el-select>-->
      </div>
      <div>
        <!-- <el-tooltip class="item" effect="light" content="录入运单号时请将表格单元格格式请设置为文本,多个运单号请用半角英文状态下的逗号(,)分开" placement="left">
        </el-tooltip>-->
        <upload-excel-component
          :on-success="importExcel"
          ref="uploadExcel"
          style="display:inline-block;z-index:-999999;top:-999999999px;position:fixed;"
          >导入</upload-excel-component
        >
        <el-tooltip
          class="item"
          effect="light"
          content="导出格式不能修改；仅物流承运商、物流运单号支持维护"
          placement="bottom"
        >
          <el-dropdown
            trigger="click"
            size="medium"
            placement="bottom"
            class="batchbtn"
            @command="handleCommand"
          >
            <el-button type="primary" size="small">
              批量录入
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b">导出表格</el-dropdown-item>
              <el-dropdown-item command="a">导入表格</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-tooltip>
      </div>
    </div>
    <!-- <upload-excel-component :on-success="importExcel" style="display:inline-block">导入</upload-excel-component> -->
    <div class="table">
      <!-- <div style="margin-bottom:5px;">
        <span class="el-icon-info" style="font-size:12px;color:red;">说明：修改运单号请先导出表格修改后再导入</span>
      </div>-->
      <el-table
        :row-class-name="tableRowClassName"
        border
        v-loading="loading"
        :data="tableData"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column
          prop="created_at"
          label="推送日期"
          width="125"
        ></el-table-column>
        <el-table-column
          prop="as_number"
          label="服务编号"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="order_number"
          label="订单号"
          width="125"
        ></el-table-column>
        <el-table-column
          prop="user_name"
          label="客户姓名"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="user_mobile"
          label="客户电话"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="user_address"
          label="客户地址"
          width="120"
        ></el-table-column>
        <el-table-column prop="out_courier_code" label="物流承运商" width="145">
          <template slot="header" slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="按照选项[物流承运商]录入。若需录入的物流承运商在档案中没有，请提供给系统管理员维护。"
              placement="bottom"
            >
              <span class="el-icon-question">物流承运商</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.out_courier_code"
              size="mini"
              filterable
            >
              <el-option
                v-for="item in tsList"
                :label="item.provider_name"
                :value="item.provider_code + ''"
                :key="item.provider_code"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="out_courier_codes" label="物流运单号">
          <template slot="header" slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content">
                <div>a.将单元格格式设置为文本；</div>
                <div>
                  b.若一个单据存在多个运单号，请用半角英文状态下的逗号“,”隔开。
                </div>
              </div>
              <span class="el-icon-question">物流运单号</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 1, maxRows: 10 }"
                placeholder="请输入物流运单号。多个运单号，请用英文逗号“,”隔开"
                v-model="scope.row.out_courier_codes"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="out_courier_mobile" label="物流联系电话">
          <template slot="header" slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content">
                <div>将单元格格式设置为文本</div>
              </div>
              <span class="el-icon-question">物流联系电话</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              <el-input
                placeholder="请填写物流联系电话"
                size="small"
                v-model="scope.row.out_courier_mobile"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div flex="main:start" class="count-wrap">
      <div>合计</div>
      <div>总数量：{{ mainNumberCount }}</div>
    </div>
    <div flex="main:center" class="gap-top">
      <el-button type="primary" size="mini" @click="saveHandler"
        >保存</el-button
      >
    </div>
    <el-dialog
      title="确认"
      :visible.sync="dialogVisible"
      center
      append-to-body
      width="500px"
    >
      <div style="text-align:center;">
        <el-row
          type="flex"
          justify="center"
          align="middle"
          style="margin-bottom: 20px;"
        >
          <el-col :span="8"><div>类型</div></el-col>
          <el-col :span="12">
            <el-select v-model="detailed" placeholder="是否包含商品明细">
              <el-option label="含商品明细" :value="1"> </el-option>
              <el-option label="不含商品明细" :value="0"> </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row
          v-show="detailed == 0"
          type="flex"
          justify="center"
          align="middle"
          style="margin-bottom: 20px;"
        >
          <el-col :span="8"><div>是否合并数据</div></el-col>
          <el-col :span="12"
            ><el-radio v-model="isExpend" :label="1">是</el-radio
            ><el-radio v-model="isExpend" :label="0">否</el-radio></el-col
          >
        </el-row>
        <div v-show="detailed == 0">
          （当客户名称、客户电话、客户地址完全一致时）
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirm">导出</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import UploadExcelComponent from "@/components/common/UploadExcel/index.vue";
import { customExpressList } from "@/models/ts";
import {
  saveNotSystemLogisticsByAfterSale,
  getAfterSaleCourierList
} from "@/models/aftersaleModel";
import { getOrderGoodsDetail } from "@/models/orderModel";
const mergeArr = function(arr) {
  if (arr.length < 1) {
    return [];
  }
  var conut = [];
  for (let [index, item] of arr.entries()) {
    var sliceArr = arr.slice(index + 1);
    for (let [sub, i] of sliceArr.entries()) {
      if (
        item.user_name + item.mobile + item.address ===
        i.user_name + i.mobile + i.address
      ) {
        if (item.as_number && i.as_number) {
          item.as_number = item.as_number + "," + i.as_number;
        } else if (i.as_number) {
          item.as_number = i.as_number;
        }
        if (item.order_number && i.order_number) {
          item.order_number = item.order_number + "," + i.order_number;
        } else if (i.order_number) {
          item.order_number = i.order_number;
        }
        if (item.out_courier_codes && i.out_courier_codes) {
          item.out_courier_codes =
            item.out_courier_codes + "," + i.out_courier_codes;
        } else if (i.out_courier_codes) {
          item.out_courier_codes = i.out_courier_codes;
        }
        if (item.out_courier_mobile && i.out_courier_mobile) {
          item.out_courier_mobile =
            item.out_courier_mobile + "," + i.out_courier_mobile;
        } else if (i.out_courier_mobile) {
          item.out_courier_mobile = i.out_courier_mobile;
        }
        if (item.id && i.id) {
          item.id = item.id + "," + i.id;
        }
        conut.push(sub + index + 1);
      }
    }
  }
  conut = [...new Set(conut)].sort((a, b) => {
    return a - b;
  });
  var t = 0;
  for (let c of conut) {
    arr.splice(c - t, 1);
    t++;
  }
  for (let item of arr) {
    item.out_courier_codes = item.out_courier_codes.toString();
    item.out_courier_mobile = item.out_courier_mobile.toString();
    item.out_courier_codes = [
      ...new Set(item.out_courier_codes.split(","))
    ].join();
    item.out_courier_mobile = [
      ...new Set(item.out_courier_mobile.split(","))
    ].join();
  }
  return arr;
};
const expend = function(arr) {
  let expend = [];
  let indexs = [];
  for (let [index, item] of arr.entries()) {
    let mainNumbers = item.as_number.split(",");
    let orderNumbers = item.order_number.split(",");
    let ids = item.id.split(",");
    if (mainNumbers.length > 1) {
      for (let [i, mergeItem] of mainNumbers.entries()) {
        let t = Object.assign({}, item);
        t.as_number = mergeItem;
        t.order_number = orderNumbers[i];
        t.id = ids[i];
        expend.push(t);
      }
      indexs.push(index);
    }
  }
  indexs = [...new Set(indexs)].sort((a, b) => {
    return a - b;
  });
  let n = 0;
  for (let m of indexs) {
    arr.splice(m - n, 1);
    n++;
  }
  return [...arr, ...expend];
};
const iscontain = function(sourceArr, tagetArr) {
  let result = true;
  for (let item of tagetArr) {
    let flag = sourceArr.find(i => i === item);
    if (!flag) {
      result = false;
      break;
    }
  }
  return result;
};
const mergeImport = function(arr) {
  if (arr.length < 1) {
    return [];
  }
  var conut = [];
  for (let [index, item] of arr.entries()) {
    var sliceArr = arr.slice(index + 1);
    for (let [sub, i] of sliceArr.entries()) {
      if (item.id === i.id) {
        if (item.out_courier_codes && i.out_courier_codes) {
          item.out_courier_codes =
            item.out_courier_codes + "," + i.out_courier_codes;
        } else if (i.out_courier_codes) {
          item.out_courier_codes = i.out_courier_codes;
        }
        if (item.out_courier_mobile && i.out_courier_mobile) {
          item.out_courier_mobile =
            item.out_courier_mobile + "," + i.out_courier_mobile;
        } else if (i.out_courier_mobile) {
          item.out_courier_mobile = i.out_courier_mobile;
        }
        conut.push(sub + index + 1);
      }
    }
  }
  conut = [...new Set(conut)].sort((a, b) => {
    return a - b;
  });
  var t = 0;
  for (let c of conut) {
    arr.splice(c - t, 1);
    t++;
  }
  for (let item of arr) {
    item.out_courier_codes = item.out_courier_codes.toString();
    item.out_courier_mobile = item.out_courier_mobile.toString();
    item.out_courier_codes = [
      ...new Set(item.out_courier_codes.split(","))
    ].join();
    item.out_courier_mobile = [
      ...new Set(item.out_courier_mobile.split(","))
    ].join();
  }
  return arr;
};
export default {
  name: "",
  components: { UploadExcelComponent },
  data() {
    return {
      ts: "",
      tsList: [],
      orderIds: "", // 订单id
      loading: false,
      downloadLoading: false,
      tableData: [],
      failedRowIndex: [], // 错误行
      isFactory: localStorage.getItem("shop_type") === "2",
      isExpend: 0, // 是否合并数据
      dialogVisible: false,
      params: {}, // 数据查询条件
      detailed: 0
    };
  },
  watch: {},
  computed: {
    mainNumberCount() {
      return this.tableData.length;
    },
    boxNumberCount() {
      let count = 0;
      this.tableData.forEach(item => {
        if (typeof Number(item.box_num) === "number") {
          count += Number(item.box_num);
        }
      });
      return count;
    },
    tsNumberCount() {
      let count = 0;
      this.tableData.forEach(item => {
        if (item.out_courier_codes) {
          let tsNumList = (item.out_courier_codes + "").split(",");
          count += tsNumList.length;
        }
      });
      return count;
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      for (const i of this.failedRowIndex) {
        if (rowIndex === i) {
          return "error-row";
        }
      }
      return "";
    },
    // X关闭当前页
    closeCurrntPage() {
      this.$router.push("/afterSale/manage");
    },
    // 导入excel
    importExcel({ results, header }) {
      this.failedRowIndex = [];
      // 推送日期,主单号 编号 单号数 承运商编号 子单号
      console.log(results, header, "导入excel");
      // 不含商品
      let arr = [
        "ID",
        "服务编号",
        "订单号",
        "客户姓名",
        "客户电话",
        "客户地址",
        "物流承运商",
        "物流运单号",
        "物流联系电话"
      ];
      // 含商品
      let detailArr = [
        "ID",
        "服务编号",
        "订单号",
        "客户姓名",
        "客户电话",
        "客户地址",
        "商品名称",
        "实发数量",
        "物流承运商",
        "物流运单号",
        "物流联系电话"
      ];
      if (iscontain(header, detailArr)) {
        // 含商品明细导入
        let resultsList = results.map(item => {
          let obj = {
            order_number: item["订单号"] || "",
            as_number: item["服务编号"] || "",
            user_name: item["客户姓名"] || "",
            user_mobile: item["客户电话"] || "",
            user_address: item["客户地址"] || "",
            name: item["商品名称"],
            send_amount: item["实发数量"],
            out_courier_code: this.getTsCode(item["物流承运商"]) || "",
            out_courier_codes: item["物流运单号"] || "",
            out_courier_mobile: item["物流联系电话"] || "",
            id: item["ID"] || ""
          };
          return obj;
        });
        let checkResult = true;
        resultsList.forEach(item => {
          item.out_courier_codes = item.out_courier_codes.toString();
          item.out_courier_codes = item.out_courier_codes
            ? item.out_courier_codes.replace(/，|,|，|, /gi, ",")
            : "";
          item.out_courier_codes = [
            ...new Set(item.out_courier_codes.split(","))
          ].join();
          item.err_cause = "";
          if (item.out_courier_code === "") {
            checkResult = false;
            item.err_cause += "物流承运商不可为空！";
          } else {
            for (let point of resultsList) {
              if (
                point.id === item.id &&
                point.out_courier_code != "" &&
                point.out_courier_code != item.out_courier_code
              ) {
                checkResult = false;
                item.err_cause += "物流承运商不一致！";
                break;
              }
            }
          }
          if (item.out_courier_codes === "" && item.out_courier_mobile === "") {
            checkResult = false;
            item.err_cause += "物流运单号与物流联系电话不可同时为空！";
          }
          if (item.out_courier_mobile !== "") {
            for (let point of resultsList) {
              if (
                point.id === item.id &&
                point.out_courier_mobile != "" &&
                point.out_courier_mobile != item.out_courier_mobile
              ) {
                checkResult = false;
                item.err_cause += "物流联系电话不一致！";
                break;
              }
            }
          }
          if (item.err_cause !== "") {
            item.err_cause = `${item.id}:${item.err_cause}`;
          }
        });
        if (checkResult) {
          let listR = mergeImport(resultsList);
          this.tableData.forEach(item => {
            let order = listR.find(result => {
              return (
                item.as_number + "" + item.id ==
                result.as_number + "" + result.id
              );
            });
            if (order) {
              item.out_courier_code = order.out_courier_code;
              item.out_courier_codes = order.out_courier_codes;
              item.out_courier_mobile = order.out_courier_mobile;
            }
          });
          this.$message.success("导入成功！");
        } else {
          this.$confirm("导入数据有误，是否下载查看原因？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          }).then(() => {
            import("@/vendor/Export2Excel").then(excel => {
              let tHeader = [
                "ID",
                "服务编号",
                "订单号",
                "客户姓名",
                "客户电话",
                "客户地址",
                "商品名称",
                "实发数量",
                "物流承运商",
                "物流运单号",
                "物流联系电话",
                "错误原因"
              ];
              let filterVal = [
                "id",
                "as_number",
                "order_number",
                "user_name",
                "user_mobile",
                "user_address",
                "name",
                "send_amount",
                "out_courier_code",
                "out_courier_codes",
                "out_courier_mobile",
                "err_cause"
              ];
              const data = this.formatJson(filterVal, resultsList);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename:
                  "售后单填写物流信息错误原因" +
                  moment().format("YYYY-MM-DD HH:mm:ss"),
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          });
        }
      } else if (iscontain(header, arr)) {
        // 不含商品明细
        let resultsList = results.map(item => {
          let obj = {
            order_number: item["订单号"] || "",
            as_number: item["服务编号"] || "",
            user_name: item["客户姓名"] || "",
            user_mobile: item["客户电话"] || "",
            user_address: item["客户地址"] || "",
            out_courier_code: this.getTsCode(item["物流承运商"]) || "",
            out_courier_codes: item["物流运单号"] || "",
            out_courier_mobile: item["物流联系电话"] || "",
            id: item["ID"] || ""
          };
          return obj;
        });
        let checkResult = true;
        resultsList.forEach(item => {
          item.out_courier_codes = item.out_courier_codes.toString();
          item.out_courier_codes = item.out_courier_codes
            ? item.out_courier_codes.replace(/，|,|，|, /gi, ",")
            : "";
          item.out_courier_codes = [
            ...new Set(item.out_courier_codes.split(","))
          ].join();
          item.err_cause = "";
          if (item.out_courier_code === "") {
            checkResult = false;
            item.err_cause += "物流承运商不可为空！";
          } else {
            for (let point of resultsList) {
              if (
                point.id === item.id &&
                point.out_courier_code != "" &&
                point.out_courier_code != item.out_courier_code
              ) {
                checkResult = false;
                item.err_cause += "物流承运商不一致！";
                break;
              }
            }
          }
          if (item.out_courier_codes === "" && item.out_courier_mobile === "") {
            checkResult = false;
            item.err_cause += "物流运单号与物流联系电话不可同时为空！";
          }
          if (item.err_cause !== "") {
            item.err_cause = `${item.id}:${item.err_cause}`;
          }
        });
        if (checkResult) {
          let listR = expend(resultsList);
          this.tableData.forEach(item => {
            let order = listR.find(result => {
              return (
                item.as_number + "" + item.id ==
                result.as_number + "" + result.id
              );
            });
            if (order) {
              item.out_courier_code = order.out_courier_code;
              item.out_courier_codes = order.out_courier_codes;
              item.out_courier_mobile = order.out_courier_mobile;
            }
          });
          this.$message.success("导入成功！");
        } else {
          this.$confirm("导入数据有误，是否下载查看原因？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          }).then(() => {
            import("@/vendor/Export2Excel").then(excel => {
              let tHeader = [
                "ID",
                "服务编号",
                "订单号",
                "客户姓名",
                "客户电话",
                "客户地址",
                "物流承运商",
                "物流运单号",
                "物流联系电话",
                "错误原因"
              ];
              let filterVal = [
                "id",
                "as_number",
                "order_number",
                "user_name",
                "user_mobile",
                "user_address",
                "out_courier_code",
                "out_courier_codes",
                "out_courier_mobile",
                "err_cause"
              ];
              const data = this.formatJson(filterVal, resultsList);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename:
                  "售后单填写物流信息错误原因" +
                  moment().format("YYYY-MM-DD HH:mm:ss"),
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          });
        }
      } else {
        this.$message.error("请检查表头是否正确");
      }
    },
    // 导出excel
    exportExcel() {
      this.formatData();
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(async excel => {
        let tHeader = [];
        let filterVal = [];
        let list = JSON.parse(JSON.stringify(this.tableData));

        if (this.detailed !== 1) {
          // 不含商品明细
          tHeader = [
            "ID",
            "服务编号",
            "订单号",
            "客户姓名",
            "客户电话",
            "客户地址",
            "物流承运商",
            "物流运单号",
            "物流联系电话"
          ];
          filterVal = [
            "id",
            "as_number",
            "order_number",
            "user_name",
            "user_mobile",
            "user_address",
            "out_courier_code",
            "out_courier_codes",
            "out_courier_mobile"
          ];
          // 合并
          if (this.isExpend === 1 && this.detailed !== 1) {
            list = mergeArr(list);
          }
          const data = this.formatJson(filterVal, list);
          console.table(data);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename:
              "售后单-录入物流运单-普通（不含商品明细）" +
              moment().format("YYYY-MM-DD HH:mm:ss"),
            autoWidth: true,
            bookType: "xlsx"
          });
          this.downloadLoading = false;
        } else {
          // 含商品明细
          tHeader = [
            "ID",
            "服务编号",
            "订单号",
            "客户姓名",
            "客户电话",
            "客户地址",
            "商品名称",
            "实发数量",
            "物流承运商",
            "物流运单号",
            "物流联系电话"
          ];
          filterVal = [
            "id",
            "as_number",
            "order_number",
            "user_name",
            "user_mobile",
            "user_address",
            "name",
            "send_amount",
            "out_courier_code",
            "out_courier_codes",
            "out_courier_mobile"
          ];
          let ids = list.map(item => item.id);
          let goodsListData =
            (await getOrderGoodsDetail({ ids: ids.join(), type: 2 })) || [];
          goodsListData.forEach(item => {
            let order = list.find(result => {
              return item.order_id === result.id;
            });
            return Object.assign(item, order);
          });
          let newGoodslist = [];
          list.forEach(item => {
            goodsListData.forEach(i => {
              if (item.id === i.order_id) {
                newGoodslist.push(i);
              }
            });
          });
          const data = this.formatJson(filterVal, newGoodslist);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename:
              "售后单-录入物流运单-普通（含商品明细）" +
              moment().format("YYYY-MM-DD HH:mm:ss"),
            autoWidth: true,
            bookType: "xlsx"
          });
          this.downloadLoading = false;
        }
      });
    },
    getTsName(id) {
      let name = "";
      // console.log(this.tsList, 'this.tsList')
      this.tsList.forEach(item => {
        if (item.provider_code === id) {
          name = item.provider_name;
        }
      });
      return name;
    },
    getTsCode(name) {
      let code = "";
      // console.log(this.tsList, 'this.tsList')
      this.tsList.forEach(item => {
        if (item.provider_name === name) {
          code = item.provider_code;
        }
      });
      return code;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "out_courier_code") {
            return this.getTsName(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    handleCommand(val) {
      console.log(val, "drop");
      // 导出
      if (val === "b") {
        this.dialogVisible = true;
      }
      // 导入
      if (val === "a") {
        this.$refs.uploadExcel.handleUpload();
      }
    },
    // 逗号更换
    formatData() {
      this.tableData.forEach(item => {
        item.out_courier_codes = item.out_courier_codes
          ? item.out_courier_codes.replace(/，|,|，|, /gi, ",")
          : "";
      });
    },
    confirm() {
      // 合并
      if (this.isExpend === 1 && this.detailed !== 1) {
        let list = JSON.parse(JSON.stringify(this.tableData));
        let listMerge = true;
        for (let item of list) {
          for (let i of list) {
            if (
              item.user_name + item.user_mobile + item.user_address ===
              i.user_name + i.user_mobile + i.user_address
            ) {
              if (item.out_courier_code !== i.out_courier_code) {
                listMerge = false;
              }
            }
          }
          if (!listMerge) {
            break;
          }
        }
        if (!listMerge) {
          this.$confirm(
            "存在物流承运商不一致，若合并导出仅保留第一条物流承运商。是否继续合并导出？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true
            }
          ).then(() => {
            this.exportExcel();
          });
        } else {
          this.exportExcel();
        }
      } else {
        this.exportExcel();
      }
      this.dialogVisible = false;
    },
    // 提交数据校验物流承运商是否为空  打包箱数是否和单号一致
    checkTableData() {
      let errorType = 1; // 错误类型 -1没有快递单号 -2快递单号与打包箱数不符  -3快递单号格式错误 -4承运商为空
      let failedRowIndexList = [];
      let reg = /^[A-Za-z0-9]+$/;
      this.tableData.forEach((item, index) => {
        let tsNumList = [];
        if (item.out_courier_codes) {
          tsNumList = (item.out_courier_codes + "").split(",");
        }
        if (!item.out_courier_code) {
          failedRowIndexList.push(index);
          errorType = -4;
        } else if (!item.out_courier_codes) {
          failedRowIndexList.push(index);
          errorType = -1;
        } else {
          let every = tsNumList.every(item => {
            return reg.test(item);
          });
          if (!every) {
            failedRowIndexList.push(index);
            errorType = -3;
          }
        }
      });
      this.failedRowIndex = [...new Set(failedRowIndexList)];
      console.log(this.failedRowIndex, " this.failedRowIndex");
      return errorType;
    },
    // 提交更改
    saveHandler() {
      this.formatData();
      let errorType = this.checkTableData();
      if (errorType > 0) {
        let data = this.tableData.map(item => {
          return {
            id: item.id,
            order_number: item.order_number,
            as_number: item.as_number,
            courier_number: item.out_courier_codes,
            courier_name: this.getTsName(item.out_courier_code),
            courier_code: item.out_courier_code,
            courier_mobile: item.out_courier_mobile
          };
        });
        saveNotSystemLogisticsByAfterSale({
          items: JSON.stringify(data)
        }).then(res => {
          this.$message.success("保存成功");
        });
      } else {
        if (errorType === -1) {
          this.$message.error("单号为空,请填写后保存");
        }
        if (errorType === -3) {
          this.$message.error("单号格式错误");
        }
        if (errorType === -4) {
          this.$message.error("承运商为空,请选择后保存");
        }
      }
    },
    async getData() {
      let ids = this.$route.query.ids;
      let Data = await getAfterSaleCourierList({
        ids: ids
      });
      this.tableData = Data.data || [];
    }
  },
  async created() {
    try {
      let tsList = await customExpressList({});
      if (tsList.code === 200) {
        this.tsList = tsList.data.succeed.map(item => {
          return {
            provider_code: item.logistics_code,
            provider_name: item.logistics_name
          };
        });
      }
    } catch (error) {}
    this.getData();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.closeCurrntPage {
  border-radius: 10px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  font-size: 14px;
  position: fixed;
  right: 16px;
  line-height: 20px;
  top: 53px;
  text-align: center;
  width: 94px;
  height: 20px;
  border-radius: 5px;
  background-color: white;
}
.a-upload {
  padding: 9px 15px;
  // height: 20px;
  font-size: 12px;
  line-height: 1;
  position: relative;
  cursor: pointer;
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: inline-block;
  *display: inline;
  *zoom: 1;
  vertical-align: middle;
}

.a-upload input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}

.a-upload:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
  text-decoration: none;
}
.gap-top {
  margin-top: 10px;
}
.gap-bottom {
  margin-bottom: 10px;
}
.count-wrap {
  border-top: 1px solid #d6d0d0;
  margin-top: 20px;
  padding-left: 30px;
  div {
    margin-right: 30px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aftersale/aftersalse-input-ts.vue